import { useLocation } from 'react-router-dom';

const useCustomParams = () => {
  const location = useLocation();

  const getParams = () => {
    const params = new URLSearchParams(location.search);
    const encodedParams = params.get('params');
    if (encodedParams) {
      try {
            const decoded = atob(encodedParams);
            //const decoded = decryptAes(encodedParams);
            const decodedParams = JSON.parse(decoded);
            return decodedParams;
        } catch (error) {
            console.error('Failed to decode params', error);
            return null;
        }
    }
    return null;
  };

  return getParams();
};

export default useCustomParams;